import type { HolterReferralData } from '@common/validation/customControls/cardiology/holter/utils/utils';
import type { InputComponentsMap } from '@frontend/formEngine/editForm/editForm.types';
import { GeneralPractitionerSelector } from '@frontend/components/pages/episodeCategory/customControls/GeneralPractitionerSelector';

export function getReferralDataInputComponents(): InputComponentsMap<keyof HolterReferralData> {
    const map: InputComponentsMap<keyof HolterReferralData> = new Map();

    map.set('generalPractitioner', <GeneralPractitionerSelector />);

    return map;
}
